module.exports = __webpack_public_path__ + "media/images/athletes/2238-8b510d795d6823d632653450236c108d.png";